import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as adminApi from '../api/adminApi';
import { pickErrorMessage } from '../lib/apiHelpers';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setMessage('');
    setBusy(true);
    try {
      const data = await adminApi.forgotPassword({ email });
      setMessage(data?.message || 'If an account exists, instructions have been sent.');
    } catch (err) {
      setError(pickErrorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light p-3">
      <div className="card shadow border-0" style={{ maxWidth: 420, width: '100%' }}>
        <div className="card-body p-4 p-md-5">
          <h1 className="h4 mb-3">Forgot password</h1>
          {error ? <div className="alert alert-danger py-2">{error}</div> : null}
          {message ? <div className="alert alert-success py-2">{message}</div> : null}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                id="email"
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary w-100 mb-3" disabled={busy}>
              {busy ? 'Sending…' : 'Send reset link'}
            </button>
            <Link to="/login" className="btn btn-outline-secondary w-100">
              Back to sign in
            </Link>
          </form>
        </div>
      </div>
    </div>
  );
}
